import React, { useState } from 'react';
import Modal from 'react-modal';

import FormTextArea from '../forms/FormTextArea';
import FormInput from '../forms/FormInput';
import FormSelect from '../forms/FormSelect';
import FormToggle from '../forms/FormToggle';
import api from '../../api/api';
import uri from '../../variables/uri';
import removeImg from '../../images/remove.png';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        background: '#f9f9f9',
        padding: '24px',
        maxHeight: '80%',
        minWidth: '80%'
    },
    overlay: {
        background: "#00000080"
    }
};

const SelectedTopicModal = ({ isOpen, onClose, initial, permissionArr, action, selectedSubject = undefined }) => {
    const [item, setItem] = useState(initial);
    const [errorMessage, setErrorMessage] = useState(undefined);
    const [isLoading, setIsLoading] = useState(false);
    const operationArr = ['Please select', '>', '<='];

    const onSubmit = async () => {
        setIsLoading(true);
        if (!item.hasCondition) setItem({
            ...item,
            ...item.detail = []
        })
        try {
            if (action === 'add') {
                setItem({
                    ...item,
                    ...item.bookSubjectId = selectedSubject.BookSubjectID
                })
                api.post(uri.POST_CREATE_BOOK, item).then(response => {

                }).catch(ex => {
                    const { Message } = ex.response.data;
                    setErrorMessage(Message);
                });
            } else if (action === 'edit') {
                api.post(uri.POST_UPDATE_BOOK, item);
            }
        } catch (ex) {

        } finally {
            setIsLoading(false);
        }
    }

    const onRemoveDetail = (i) => {
        const detail = item.detail;
        detail.splice(i, 1);
        setItem({
            ...item,
            ...item.detail = detail
        })
    }

    const onTopicNoChange = (value) => setItem({ ...item, ...item.topicNo = value });
    const onTopicTitleChange = (value) => setItem({ ...item, ...item.topicTitle = value });
    const onHasConditionChange = (value) => {
        setItem({ ...item, ...item.hasCondition = value });
        if (item.detail.length === 0) addItem(0);
    }
    const onTopicApproveChange = (value) => setItem({ ...item, ...item.approve = value });
    const onTopicSignChange = (value) => setItem({ ...item, ...item.sign = value });
    const onTopicReportChange = (value) => setItem({ ...item, ...item.report = value });
    const onTopicApproveTextChange = (value) => setItem({ ...item, ...item.approveText = value });
    const onTopicSignTextChange = (value) => setItem({ ...item, ...item.signText = value });
    const onTopicReportTextChange = (value) => setItem({ ...item, ...item.reportText = value });
    const onTopicRemarkChange = (value) => setItem({ ...item, ...item.remark = value });
    const onTopicCommentChange = (value) => setItem({ ...item, ...item.comment = value });
    // const onTopicTypeChange = (type) => setItem({ ...item, ...item.type = type });
    const onConditionTitleChange = (value, element) => setItem({ ...item, ...element.conditionTitle = value });
    const onConditionTypeChange = (type) => {

        setItem({ ...item, ...item.conditionType = type })
    };
    const onOperationChange = (value, element) => setItem({ ...item, ...element.operation = value });
    const onConditionApproveChange = (value, element) => setItem({ ...item, ...element.approve = value });
    const onConditionSignChange = (value, element) => setItem({ ...item, ...element.sign = value });
    const onConditionReportChange = (value, element) => setItem({ ...item, ...element.report = value });
    const onConditionRemarkChange = (value, element) => setItem({ ...item, ...element.remark = value });
    const onConditionValueChange = (value, element) => setItem({ ...item, ...element.value = value });
    const onConditionApproveTextChange = (value, element) => setItem({ ...item, ...element.approveText = value });
    const onConditionSignTextChange = (value, element) => setItem({ ...item, ...element.signText = value });
    const onConditionReportTextChange = (value, element) => setItem({ ...item, ...element.reportText = value });
    const onConditionCommentChange = (value, element) => setItem({ ...item, ...element.comment = value });

    const addItem = (sequence) => {
        setItem({
            ...item, ...item.detail.push({
                conditionId: undefined,
                conditionDetailId: undefined,
                conditionTitle: '',
                squence: sequence + 1,
                operation: '',
                value: 0,
                approve: undefined,
                sign: undefined,
                report: undefined,
                approveText: null,
                signText: null,
                reportText: null,
                remark: null,
                comment: null
            })
        });
    }

    if (initial.hasCondition && initial.detail.length === 0) addItem(initial.detail.length);

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            style={customStyles}
            contentLabel="Message">
            <div>
                <div style={{ minWidth: '300px' }} className="flex-h flex-between">
                    <div>
                        <h1 className="f-200">{action === 'add' ? `Add Topic to ${selectedSubject.SubjectTitle}` : `Edit Topic ${item.topicNo} of ${selectedSubject.SubjectTitle}`}</h1>
                        <h4 className="f-300">{action === 'add' ? 'Add New Topic' : 'Edit Informations of Topic'}</h4>
                    </div>
                </div>
                <div className="mt-16 mb-16" style={{ border: '1px solid #ddd', borderRadius: '20px' }}></div>
                <FormInput
                    name="No."
                    value={item.topicNo}
                    onValueChange={onTopicNoChange}
                    readonly={action === 'edit' ? true : false}
                />
                <FormTextArea
                    value={item.topicTitle}
                    onValueChange={onTopicTitleChange}
                    placeholder='Topic Title..'
                    name='Topic Title'
                />
                {action === 'add' &&
                    <FormToggle
                        name='Condition'
                        type1='Have'
                        type2='Not Have'
                        onValueChange={onHasConditionChange}
                        value={item.hasCondition}
                        boolean={true} />}
                {/* <FormToggle
                    name='Type'
                    type1='Amount'
                    type2='Selection'
                    onValueChange={onTopicTypeChange}
                    value={item.type} /> */}
                <FormInput
                    name="Comment"
                    onValueChange={onTopicCommentChange}
                    value={item.comment} />
                {!item.hasCondition ?
                    <div>
                        <FormSelect
                            name="Approve"
                            value={item.approve}
                            onValueChange={onTopicApproveChange}
                            options={permissionArr}
                            assign={true} />
                        <FormInput
                            value={item.approveText}
                            onValueChange={onTopicApproveTextChange}
                            name='Approve Text'
                        />
                        <FormSelect
                            name="Sign"
                            value={item.sign}
                            onValueChange={onTopicSignChange}
                            options={permissionArr}
                            assign={true} />
                        <FormSelect
                            name="Report"
                            value={item.report}
                            onValueChange={onTopicReportChange}
                            options={permissionArr}
                            assign={true} />
                        <FormInput
                            value={item.reportText}
                            onValueChange={onTopicReportTextChange}
                            name='Report Text'
                        />
                        <FormInput
                            value={item.signText}
                            onValueChange={onTopicSignTextChange}
                            name='Sign Text' />
                        <FormInput
                            value={item.remark}
                            onValueChange={onTopicRemarkChange}
                            name='Remark'
                        />
                    </div> :
                    <div>
                        <h1 className="mt-24 text-center">Condition</h1>
                        {item.detail.map((element, i) => {
                            return (
                                <div key={i} className="card mt-16 pb-16 pl-16 pr-16">
                                    <div className="flex-h flex-between">
                                        <div />
                                        <img onClick={() => onRemoveDetail(i)} style={{ width: '18px', cursor: 'pointer' }} src={removeImg} alt="" />
                                    </div>
                                    <FormTextArea
                                        value={element.conditionTitle}
                                        onValueChange={onConditionTitleChange}
                                        placeholder='Condition Title..'
                                        name='Condition Title'
                                        element={element} />
                                    <FormToggle
                                        name='Type'
                                        type1='Amount'
                                        type2='Selection'
                                        onValueChange={onConditionTypeChange}
                                        value={item.conditionType} />
                                    <FormSelect
                                        name="Operation"
                                        options={operationArr}
                                        value={element.operation}
                                        onValueChange={onOperationChange}
                                        element={element} />
                                    {item.conditionType === 'A' &&
                                        <FormInput
                                            name="Value"
                                            onValueChange={onConditionValueChange}
                                            value={element.value}
                                            element={element} />}
                                    <FormSelect
                                        name="Approve"
                                        value={element.approve}
                                        onValueChange={onConditionApproveChange}
                                        options={permissionArr}
                                        element={element}
                                        assign={true} />
                                    <FormInput
                                        value={element.approveText}
                                        onValueChange={onConditionApproveTextChange}
                                        name='Approve Text'
                                        element={element} />
                                    <FormSelect
                                        name="Sign"
                                        value={element.sign}
                                        onValueChange={onConditionSignChange}
                                        options={permissionArr}
                                        element={element}
                                        assign={true} />
                                    <FormInput
                                        value={element.signText}
                                        onValueChange={onConditionSignTextChange}
                                        name='Sign Text'
                                        element={element} />
                                    <FormSelect
                                        name="Report"
                                        value={element.report}
                                        onValueChange={onConditionReportChange}
                                        options={permissionArr}
                                        element={element}
                                        assign={true} />
                                    <FormInput
                                        value={element.reportText}
                                        onValueChange={onConditionReportTextChange}
                                        name='Report Text'
                                        element={element} />
                                    <FormInput
                                        value={element.remark}
                                        onValueChange={onConditionRemarkChange}
                                        name='Remark'
                                        element={element} />
                                    <FormInput
                                        value={element.comment}
                                        onValueChange={onConditionCommentChange}
                                        name='Comment'
                                        element={element} />
                                </div>
                            );
                        })}
                        <p className="button-add-condition" onClick={() => addItem(item.detail.length)}>Add Condition Detail</p>
                    </div>
                }
                <h3 className="has-text-danger mt-24 has-text-centered">{errorMessage}</h3>
                <button disabled={!item.topicNo || !item.topicTitle} onClick={() => onSubmit()} className={`mt-24 button is-success is-fullwidth center ${isLoading && 'is-loading'}`}>Confirm</button>
            </div>
        </Modal>
    );
}

export default SelectedTopicModal;